import { Injectable, signal } from '@angular/core';

// App-wide "Login Required" popup state. Opened by authGuard when a logged-out
// user tries to reach a protected page; rendered once in app.html.
@Injectable({
  providedIn: 'root'
})
export class LoginPromptService {
  readonly isOpen = signal(false);
  readonly pageName = signal('');

  open(pageName: string): void {
    this.pageName.set(pageName);
    this.isOpen.set(true);
  }

  close(): void {
    this.isOpen.set(false);
  }
}
